import { React, useState } from 'react';

import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { pt } from 'date-fns/locale';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import { formatIsoDate } from '../../utils/dateUtils';
import { fetchFlask } from '../../utils/fetchFlask';

const ValidarFatura = () => {
  const initialFormState = {
    telefone: '',
    titular: '',
    cc: '',
    instalacao: '',
    consumoMedio: 0,
    dateTime: null,
    rua: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    estado: '',
    cep: '',
    altaTensao: false,
    crefaz: false,
    baixaRenda: false,
    ilegivel: false,
    parcelamento: false,
    importe: false,
    incompleta: false,
    comprovante: false
  };

  const simpleForm = {
    titular: 't',
    cc: '1',
    instalacao: 1,
    dateTime: null,
    rua: 'R',
    numero: '1',
    complemento: 'C',
    bairro: 'B',
    cidade: 'C',
    estado: 'Pernambuco',
    cep: '1'
  };

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const [form, setForm] = useState(initialFormState);
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('');
  const [openAlerta, setOpenAlerta] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);

  const today = new Date();
  const minDate = new Date(today.getFullYear(), today.getMonth() - 7, 1);
  const maxDate = new Date(today.getFullYear(), today.getMonth() + 1, 1);

  const handleChangeSimple = () => {
    setForm(prev => ({
      ...prev,
      ...simpleForm
    }));
  };

  const hideForm = form.importe || form.ilegivel || form.baixaRenda || form.crefaz || form.altaTensao || form.incompleta || form.comprovante || form.parcelamento;

  async function getAddressData() {
    const body = JSON.stringify({ cep: form.cep });

    const response = await fetchFlask('buscarDadosCEP', body);

    if (response.status === 'success') {
      setForm(prev => ({
        ...prev,
        rua: response.data.logradouro,
        bairro: response.data.bairro,
        cidade: response.data.localidade,
        estado: response.data.estado
      }));
    } else {
      setMessage(response.message);
      setStatus(response.status);
      setOpenAlerta(true);
    }
  }

  async function submitValidarFatura(e) {
    e.preventDefault();
    setIsSubmit(true);

    const periodo = form.dateTime ? formatIsoDate(form.dateTime) : '';

    const body = JSON.stringify({
      codigo_do_cliente: form.cc,
      titular: form.titular,
      telefone: form.telefone,
      instalacao: form.instalacao,
      periodo,
      consumo_medio: form.consumoMedio,
      endereco: {
        rua: form.rua,
        numero: form.numero,
        bairro: form.bairro,
        complemento: form.complemento,
        cidade: form.cidade,
        estado: form.estado,
        cep: form.cep
      },
      crefaz: form.crefaz,
      ilegivel: form.ilegivel,
      importe: form.importe,
      alta_tensao: form.altaTensao,
      baixa_renda: form.baixaRenda,
      incompleta: form.incompleta,
      parcelamento: form.parcelamento,
      comprovante: form.comprovante
    });

    const response = await fetchFlask('chatgpt/validarFatura', body);

    setMessage(response.message);
    setStatus(response.status);
    setOpenAlerta(true);
    setIsSubmit(false);
    setForm(initialFormState);
  }

  return (

    <Box className="mainBox">

      <Alerta
        texto={message}
        status={status}
        open={openAlerta}
        handleClose={() => setOpenAlerta(false)}
      />

      <Paper elevation={3} sx={{ maxWidth: 1200, margin: 'auto', p: 1 }}>

        <PageHeader>Validação de Fatura</PageHeader>

        <Divider sx={{ mb: 1 }} />

        <form onSubmit={submitValidarFatura}>
          <Stack spacing={1}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Informações Básicas
                </Typography>

                <Grid container spacing={1}>

                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      required
                      label="Telefone"
                      value={form.telefone}
                      onChange={(e) => handleChange('telefone', e.target.value)}
                    />
                  </Grid>

                </Grid>
              </CardContent>
            </Card>

            <Card>
              <CardContent>

                <Typography variant="h6" gutterBottom>
                  Ocorrências
                </Typography>

                <Grid container spacing={1}>

                  {[
                    ['altaTensao', 'Alta Tensão'],
                    ['crefaz', 'Crefaz'],
                    ['parcelamento', 'Parcelamento'],
                    ['baixaRenda', 'Baixa Renda'],
                    ['ilegivel', 'Ilegível'],
                    ['importe', 'Importe'],
                    ['incompleta', 'Incompleta'],
                    ['comprovante', 'Comprovante']
                  ].map(([key, label]) => (

                    <Grid item xs={12} sm={6} md={3} key={key}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={form[key]}
                            onChange={(e) => {
                              handleChange(key, e.target.checked);
                              handleChangeSimple();
                            }}
                          />
                        }
                        label={label}
                      />
                    </Grid>

                  ))}

                </Grid>
              </CardContent>
            </Card>

            {!hideForm && (

              <>
                <Card>
                  <CardContent>

                    <Typography variant="h6" gutterBottom>
                      Dados da Fatura
                    </Typography>

                    <Grid container spacing={2}>

                      <Grid item xs={12} md={4}>
                        <TextField
                          fullWidth
                          label="Titular"
                          value={form.titular}
                          onChange={(e) => handleChange('titular', e.target.value)}
                        />
                      </Grid>

                      <Grid item xs={6} md={2}>
                        <TextField
                          fullWidth
                          label="Conta Contrato"
                          value={form.cc}
                          onChange={(e) => handleChange('cc', e.target.value)}
                        />
                      </Grid>

                      <Grid item xs={6} md={2}>
                        <TextField
                          fullWidth
                          label="Instalação"
                          value={form.instalacao}
                          onChange={(e) => handleChange('instalacao', e.target.value)}
                        />
                      </Grid>

                      <Grid item xs={6} md={2}>
                        <TextField
                          fullWidth
                          label="Consumo Médio"
                          type="number"
                          value={form.consumoMedio}
                          onChange={(e) => handleChange('consumoMedio', e.target.value)}
                        />
                      </Grid>

                      <Grid item xs={6} md={2}>
                        <LocalizationProvider adapterLocale={pt} dateAdapter={AdapterDateFns}>
                          <DatePicker
                            label="Período"
                            views={['month', 'year']}
                            value={form.dateTime}
                            minDate={minDate}
                            maxDate={maxDate}
                            onChange={(value) => handleChange('dateTime', value)}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>

                <Card>
                  <CardContent>

                    <Typography variant="h6" gutterBottom>
                      Endereço
                    </Typography>

                    <Grid container spacing={1}>

                      <Grid item xs={12} md={3}>
                        <TextField
                          fullWidth
                          label="CEP"
                          value={form.cep}
                          onChange={(e) => handleChange('cep', e.target.value)}
                        />
                      </Grid>

                      <Grid item xs={12} md={2}>
                        <Button
                          fullWidth
                          variant="contained"
                          sx={{ height: '56px' }}
                          onClick={getAddressData}
                        >
                          Buscar CEP
                        </Button>
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <TextField
                          fullWidth
                          label="Rua"
                          value={form.rua}
                          onChange={(e) => handleChange('rua', e.target.value)}
                        />
                      </Grid>

                      <Grid item xs={6} md={1}>
                        <TextField
                          fullWidth
                          label="Número"
                          value={form.numero}
                          onChange={(e) => handleChange('numero', e.target.value)}
                        />
                      </Grid>

                      <Grid item xs={6} md={2}>
                        <TextField
                          fullWidth
                          label="Complemento"
                          value={form.complemento}
                          onChange={(e) => handleChange('complemento', e.target.value)}
                        />
                      </Grid>

                      <Grid item xs={6} md={3}>
                        <TextField
                          fullWidth
                          label="Bairro"
                          value={form.bairro}
                          onChange={(e) => handleChange('bairro', e.target.value)}
                        />
                      </Grid>

                      <Grid item xs={6} md={3}>
                        <TextField
                          fullWidth
                          label="Cidade"
                          value={form.cidade}
                          onChange={(e) => handleChange('cidade', e.target.value)}
                        />
                      </Grid>

                      <Grid item xs={6} md={2}>
                        <TextField
                          fullWidth
                          label="Estado"
                          value={form.estado}
                          onChange={(e) => handleChange('estado', e.target.value)}
                        />
                      </Grid>

                    </Grid>
                  </CardContent>
                </Card>
              </>
            )}

            <Box textAlign="center">
              <SubmitButton isSubmit={isSubmit}>
                Validar Fatura
              </SubmitButton>
            </Box>
          </Stack>
        </form>
      </Paper>
    </Box>
  );
};

export default ValidarFatura;
